import { toast } from 'react-toastify';
import { CUSTOMER_COLUMNS, truncateText } from './customerColumns';

const excelKey = (key) => key.replace(/\s/g, '_').replace(/\./g, '');

/**
 * "Tabloyu İndir": every customer, with the columns visible in the table (in
 * table order, Turkish headers as before). `messages`: the notifications in
 * the current language; the file itself doesn't change with the language.
 */
export const downloadCustomersExcel = async ({ customers, columnKeys, messages }) => {
  try {
    toast.info(messages.preparing);
    const ExcelJS = (await import('exceljs')).default;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Müşteriler');

    worksheet.columns = columnKeys.map((key) => ({
      header: CUSTOMER_COLUMNS[key].label,
      key: excelKey(key),
      width: 20,
    }));

    customers.forEach((customer) => {
      const rowData = {};
      columnKeys.forEach((key) => {
        rowData[excelKey(key)] = truncateText(customer[key]);
      });
      worksheet.addRow(rowData);
    });

    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFE5E7EB' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF111827' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    const date = new Date();
    const formattedDate = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Müşteriler_${formattedDate}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);

    toast.success(messages.success);
  } catch (error) {
    console.error('Error downloading Excel:', error);
    toast.error(messages.error);
  }
};
